import {rules as v} from '../scripts/rules';

const profilbeschreibung = {
	"Profilnr"    : v.isNum,
	"Schnittnr"   : v.isNum,
	"Planumsnr"   : v.isNumManyWithoutDash,
	"Befundnr"    : v.isNumManyWithoutDash,
	"Beschreibung": v.isFreetext,
	"Fotonr"      : v.isNumManyWithoutDash,
	"Datum"       : v.isDate,
	"BearbeiterIn": v.isFreetextNotEmpty,
	"Verworfen"   : v.isJN
}

export default profilbeschreibung;
